import { render, staticRenderFns } from "./Exfoliants.vue?vue&type=template&id=2974f41e"
import script from "./Exfoliants.vue?vue&type=script&lang=js"
export * from "./Exfoliants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports